import React from 'react';
import { useLocation } from 'react-router-dom';
import ExecutionList from './ExecutionList';
import ExperimentResults from '../ExperimentManager/ExperimentResults';

const ExecutionManager = () => {
  const location = useLocation();

  const renderContent = () => {
    const path = location.pathname;

    if (path.includes('/executions/experiments')) {
      return (
        <div data-testid="executions-page">
          <ExperimentResults />
        </div>
      );
    } else {
      return (
        <div data-testid="executions-page">
          <ExecutionList />
        </div>
      );
    }
  };

  return renderContent();
};

export default ExecutionManager;
